import { AutogenLayoutCustomFuelSurchargeTablesList } from "./autogen/AutogenLayoutCustomFuelSurchargeTablesList";

export class CustomFuelSurchargeTablesList extends AutogenLayoutCustomFuelSurchargeTablesList {
    
    onLoad(): void | Promise<void> {
        this.mainDataSource.search();
    }
}
